export var SET_ASYNC_DATA = 'SET_ASYNC_DATA';
export var SET_LOADING = 'SET_LOADING';